import React from 'react';
import {
  EQUIPMENT_FIELD_DEFS,
  formatEquipmentFieldPlain,
  normalizeEquipmentRecord,
} from '../utils/equipmentDisplay';
import { TABLE_HEADER_CELL_CLASS } from './Table';

const DEFAULT_CELL = 'px-3 py-3 text-sm text-gray-700';

export function EquipmentTableHeaderRow({ excludeKeys = [], extraBefore = null, extraAfter = null }) {
  const defs = EQUIPMENT_FIELD_DEFS.filter((d) => !excludeKeys.includes(d.key));
  return (
    <>
      {extraBefore}
      {defs.map((def) => (
        <th
          key={def.key}
          className={`px-3 py-3 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider ${TABLE_HEADER_CELL_CLASS}`}
        >
          {def.label}
        </th>
      ))}
      {extraAfter}
    </>
  );
}

export function EquipmentTableBodyCells({
  item,
  excludeKeys = [],
  className = DEFAULT_CELL,
  renderField,
}) {
  const norm = normalizeEquipmentRecord(item);
  const defs = EQUIPMENT_FIELD_DEFS.filter((d) => !excludeKeys.includes(d.key));
  return defs.map((def) => {
    if (renderField) {
      const custom = renderField(def, norm);
      if (custom !== undefined) {
        return <React.Fragment key={def.key}>{custom}</React.Fragment>;
      }
    }
    return (
      <td key={def.key} className={className}>
        <span className="line-clamp-3 break-words">{formatEquipmentFieldPlain(norm, def)}</span>
      </td>
    );
  });
}
